<ng-container *ngFor="let item of cartItems; let idx = index">
	<div class="p-grid" appendTo="body">
		<div class="p-col-8">{{ item.quantity }} {{ item.ooMenuItem.name }}</div>
		<div class="p-col-2">{{ item.quantity * item.price | currency }}</div>
		<div class="p-col-2">
			<div class="d-flex w-100">
				<div class="ms-auto">
					<fa-icon class="ms-auto" [icon]="['far', 'circle-x']" class="text-danger" size="lg" (click)="removeItemPrompt(item, idx)"></fa-icon>
				</div>
			</div>
		</div>
	</div>
</ng-container>
